import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

/**
 * 인플루언서 아이디에 해당하지 않는 nutrientColumnDescription에서 가져오기
 * @param param
 * @returns {Promise<never>}
 */
const getAllCategory = async (param) => {
	const { data } = await axios.get(`${baseUrl}/partners/read/nutrient-column`, {
		params: param,
	});
	return data;
};

/**
 * 카테고리별 컨텐츠 목록 조회하기
 * @param param
 * @param param.catetgoryId 0 - 없음 | 1 - 소통글 | 2 - 클래스 | 3 - 공동구매 | 4 - 영양제 추천
 * @param param.userId partners_id
 * @param param.offset
 * @param param.pageSize
 * @returns {Promise<never>}
 */
const getContentsByCategory = async (param) => {
	const { data } = await axios.get(
		`${baseUrl}/partners/read/content/list/all`,
		{
			params: param,
		}
	);
	return data;
};

const categoryApi = {
	getAllCategory,
	getContentsByCategory,
};

export default categoryApi;
